// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

// assets
import CssHeading from './Heading.scss';

import NON_WESTERN_LANGUAGES from '../../constants/non-western-languages';

export function getLanguageSpecificFont(subtitleLang, subtitleScript, nonWesternLanguages) {
  if (subtitleScript && subtitleScript.toLowerCase() === 'latn') {
    return '';
  }

  const robotoLangs = ['vi', 'ru', 'uk', 'ja'];

  if (robotoLangs.includes(subtitleLang)) {
    return 'heading--non-western-roboto-condensed';
  }

  if ((nonWesternLanguages || NON_WESTERN_LANGUAGES).includes(subtitleLang)) {
    return 'heading--non-western-font';
  }

  return '';
}

class Heading extends Component {
  static propTypes = {
    level: PropTypes.number,
    className: PropTypes.string,
    subtitleLang: PropTypes.string,
    subtitleScript: PropTypes.string,
    nonWesternLanguages: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
    withDash: PropTypes.bool,
  };

  static defaultProps = {
    level: 2,
    className: '',
    subtitleLang: 'en',
    subtitleScript: null,
    nonWesternLanguages: null,
    children: '',
    withDash: false,
  };

  render() {
    const {
      level,
      withDash,
      className,
      children,
      subtitleLang,
      subtitleScript,
      nonWesternLanguages,
      ...others
    } = this.props;
    const CustomTag = `h${level}`;
    const headingClassName = classNames(
      'heading',
      className,
      getLanguageSpecificFont(subtitleLang, subtitleScript, nonWesternLanguages),
      {
        'heading--with-dash': withDash,
      },
    );
    return (
      <CustomTag className={headingClassName} {...others}>
        {children}
      </CustomTag>
    );
  }
}

const StyledHeading = withStyles(CssHeading)(Heading);

const HeadingWithConfig = props => {
  const nonWesternLanguages = useSelector(state => state.config?.nonWesternLanguages);
  return <StyledHeading nonWesternLanguages={nonWesternLanguages} {...props} />;
};

export default HeadingWithConfig;
